import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

import { css } from 'styled-components';
import { focusOutlineColors, getHexToRgb } from "./../core";
export var unselectedStyles = {
  active: css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    background-color: ", ";\n    box-shadow: none;\n  "])), function (_ref) {
    var theme = _ref.theme;
    return theme.color.state.dark.pressed.value;
  }),
  "default": css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    outline: none;\n  "]))),
  focus: css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    box-shadow: inset 0 0 0 4px ", ";\n  "])), function (_ref2) {
    var theme = _ref2.theme;
    return theme.color.state["default"].focus.value;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return focusOutlineColors.getDark(theme);
  }),
  hover: css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    background-color: ", ";\n  "])), function (_ref4) {
    var theme = _ref4.theme;
    return theme.color.state["default"].hover.value;
  })
};
var selectedStyles = {
  active: css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    box-shadow: none;\n  "])), function (_ref5) {
    var theme = _ref5.theme;
    return "rgba(".concat(getHexToRgb(theme.color.primary[500].value), ", 0.25)");
  }),
  "default": css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    && {\n      background-color: ", ";\n      outline: none;\n    }\n  "])), function (_ref6) {
    var theme = _ref6.theme;
    return theme.color.state.primary.hover.value;
  }),
  focus: css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    box-shadow: inset 0 0 0 4px ", ";\n  "])), function (_ref7) {
    var theme = _ref7.theme;
    return "rgba(".concat(getHexToRgb(theme.color.primary[500].value), ", 0.3)");
  }, function (_ref8) {
    var theme = _ref8.theme;
    return focusOutlineColors.getPrimary(theme);
  }),
  hover: css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    background-color: ", ";\n  "])), function (_ref9) {
    var theme = _ref9.theme;
    return "rgba(".concat(getHexToRgb(theme.color.primary[500].value), ", 0.3)");
  })
};
export var getStateStyles = function getStateStyles(isSelected) {
  return isSelected ? selectedStyles : unselectedStyles;
};